import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faCheck, faGlobe, faDesktop } from '@fortawesome/free-solid-svg-icons';
import usePlatform, { PLATFORMS } from '../../hooks/usePlatform';
import './PlatformSwitcher.css';

const ICONS = { web: faGlobe, desktop: faDesktop };
const HINTS = {
  web: "L'application web (React)",
  desktop: "L'application Windows (WPF)",
};

// "Plateforme: Lonnii Web ▾" in the top bar. Switching opens that side's home page.
const PlatformSwitcher = () => {
  const { platform, switchTo, markCurrent } = usePlatform();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    markCurrent();
  }, [markCurrent]);

  useEffect(() => {
    if (!open) return undefined;
    const close = (event) => {
      if (ref.current && !ref.current.contains(event.target)) setOpen(false);
    };
    const escape = (event) => event.key === 'Escape' && setOpen(false);
    document.addEventListener('mousedown', close);
    document.addEventListener('keydown', escape);
    return () => {
      document.removeEventListener('mousedown', close);
      document.removeEventListener('keydown', escape);
    };
  }, [open]);

  const choose = (next) => {
    setOpen(false);
    if (next !== platform) switchTo(next);
  };

  return (
    <div className={`platform-switcher ${platform}`} ref={ref}>
      <button
        type="button"
        className="platform-current"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <FontAwesomeIcon icon={ICONS[platform]} className="platform-icon" />
        <span className="platform-caption">Plateforme</span>
        <span className="platform-name">{PLATFORMS[platform].label}</span>
        <FontAwesomeIcon icon={faChevronDown} className={`platform-chevron ${open ? 'up' : ''}`} />
      </button>

      {open && (
        <ul className="platform-menu" role="listbox">
          {Object.values(PLATFORMS).map((p) => (
            <li key={p.id}>
              <button
                type="button"
                role="option"
                aria-selected={p.id === platform}
                className={p.id === platform ? 'selected' : ''}
                onClick={() => choose(p.id)}
              >
                <FontAwesomeIcon icon={ICONS[p.id]} className="platform-icon" />
                <span>
                  <strong>{p.label}</strong>
                  <small>{HINTS[p.id]}</small>
                </span>
                {p.id === platform && <FontAwesomeIcon icon={faCheck} className="platform-check" />}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default PlatformSwitcher;
